export enum CHARACTER_TYPES {
  MAGE = 'MAGE',
  ROGUE = 'ROGUE',
  KNIGHT = 'KNIGHT',
  BARBARIAN = 'BARBARIAN',
  SKELETOR_MINION = 'SKELETOR_MINION',
  BASIC_MINION = 'BASIC_MINION',
  BASIC_COMMANDER = 'BASIC_COMMANDER',
  JACK = 'JACK',
  WITCH = 'WITCH',
}

export enum CHARACTER_VARIANTS {
  REGULAR = 'REGULAR',
  DIABLO = 'DIABLO',
  STATUE = 'STATUE',
  CANDY_ARMORED = 'CANDY_ARMORED',
}

export enum MAGIC_TYPE {
  FIRE = 'FIRE',
  ICE = 'ICE',
  BLACK = 'BLACK',
}

export enum OBSTACLE_TYPE {
  BASIC = 'BASIC'
}

export enum WEAPONS {
  FIST = 'FIST',
  SWORD = 'SWORD',
  AXE = 'AXE',
  BOW = 'BOW',
  SPELL_FIREBALL = 'SPELL_FIREBALL',
  SPELL_THUNDERBOLT = 'SPELL_THUNDERBOLT',
  CANDY_SWORD = 'CANDY_SWORD',
}

export enum CHARACTER_ACTION {
  AWAIT = 'AWAIT',
  RESPAWN = 'RESPAWN',
  // action to move 1 tile away, path are a chain of move actions
  MOVE = 'MOVE',
  // destinations that can be more than 1 tile away from current position
  GOTO = 'GOTO',
  LOOT = 'LOOT',
  // is in reange and must hit enemy
  ATTACK = 'ATTACK',
  // lock attack target and must resolve path
  ATTACKTO = 'ATTACKTO',
  INTERACT = 'INTERACT',
  HIT_RECEIVED = 'HIT_RECEIVED',
  DIE = 'DIE',
  // action as fallback to do nothing, for example when character is dead
  INVALID = 'INVALID'
}
export enum CHARACTER_STATES {
  IDLE = 'IDLE',
  MOVING = 'MOVING',
  INACTIVE = 'INACTIVE',
  LOOTING = 'LOOTING',
  ACTING = 'ACTING',
  BURIED = 'BURIED',
  DEAD = 'DEAD',
  CHEERING = 'CHEERING',
  // ATTACKING = 'ATTACKING',
  // INTERACTING = 'INTERACTING',
  // FALLING = 'FALLING',
}